import Button from "@mui/material/Button";
import React, { useMemo } from "react";
import { CellWrapper } from "./cellWrapper";
import { useTranslation } from "react-i18next";

export const ButtonRowCell = (props) => {
  const { t } = useTranslation();
  const {
    value: initialValue,
    row: {
      index,
      // original: { _isNewRow },
      original,
    },
    column: {
      id,
      buttonLabel,
      columnName,
      isVisible,
      isVisibleInNew = false,
      shouldExclude,
      setButtonName,
    },
    onButtonActionHandel,
  } = props;
  const is_Visible = useMemo(
    () => (Boolean(original?._isNewRow) ? isVisibleInNew : isVisible),
    [isVisible, original?._isNewRow],
  );

  const isShouldExclude = useMemo(() => {
    if (typeof shouldExclude === "function") {
      return shouldExclude(initialValue, original);
    }
    return false;
  }, [initialValue, original]);

  const handleClick = (e) => {
    //updateGridData(index, id, true, true, "");
    //console.log(onButtonActionHandel, props);
    if (typeof onButtonActionHandel === "function") {
      onButtonActionHandel(index, id);
    }
  };

  const updatedBtnName = useMemo(() => {
    if (typeof setButtonName === "function") {
      return setButtonName(initialValue, original);
    }
    return null;
  }, [initialValue, original]);

  const newColumnName = Boolean(updatedBtnName) ? updatedBtnName : columnName;

  if (isShouldExclude) {
    return <CellWrapper {...props}></CellWrapper>;
  }

  return (
    <CellWrapper {...props}>
      {is_Visible ? (
        <Button
          onClick={handleClick}
          fullWidth
          variant="contained"
          color="secondary"
          style={{ height: "28px" }}
        >
          {Boolean(buttonLabel) ? t(buttonLabel) : t(newColumnName)}
        </Button>
      ) : null}
    </CellWrapper>
  );
};
